export default "assets/images/icons/youtube-740bf9f4.svg";